import { useInView } from "@/hooks/useInView";

export default function Reveal({
  delay = 0,
  y = 24,
  duration = 900,
  children,
  className = "",
  once = true,
  threshold = 0.15,
  as: Tag = "div",
}) {
  const { ref, inView } = useInView({ threshold, once });
  const style = {
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0)" : `translateY(${y}px)`,
    transition: `opacity ${duration}ms cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms, transform ${duration}ms cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms`,
    willChange: "opacity, transform",
  };
  return (
    <Tag ref={ref} className={className} style={style}>
      {children}
    </Tag>
  );
}
